import {
  apiRequest,
  dokumenPensiunList,
  dokumenPensiunActive,
  dokumenPensiunInactive,
} from "../../../../../services/adapters/master/dokumenPensiunService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      dokumenPensiunList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      dokumenPensiunInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      dokumenPensiunActive,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
